import { useEffect, useState } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import Layout from "@/components/Layout";
import { http } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { t } from "@/lib/i18n";
import { log } from "@/lib/logger";
import { CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentSuccess() {
  const { lang, checkAuth } = useAuth();
  const nav = useNavigate();
  const loc = useLocation();
  const [status, setStatus] = useState({ payment_status: "pending" });
  const [attempts, setAttempts] = useState(0);

  useEffect(() => {
    const params = new URLSearchParams(loc.search);
    const sid = params.get("session_id");
    if (!sid) { nav("/"); return; }
    let cancelled = false;
    const tick = async () => {
      try {
        const { data } = await http.get(`/payments/status/${sid}`);
        if (cancelled) return;
        setStatus(data);
        if (data.payment_status === "paid" || attempts > 20) {
          checkAuth();
          return;
        }
        setTimeout(() => setAttempts((a) => a + 1), 2000);
      } catch (e) {
        // Poll may hit transient network errors; log for observability and keep polling.
        log.warn("[PaymentSuccess] poll failed:", e?.message || e);
      }
    };
    tick();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [loc.search, attempts]);

  const paid = status.payment_status === "paid";

  return (
    <Layout>
      <div className="max-w-lg mx-auto px-6 py-24 text-center">
        <div className={`w-16 h-16 rounded-full flex items-center justify-center mx-auto ${paid ? "bg-green-100 text-green-600" : "bg-slate-100 text-slate-500"}`}>
          {paid ? <CheckCircle2 className="w-8 h-8" /> : <div className="w-6 h-6 rounded-full border-2 border-[#1E3A8A] border-t-transparent animate-spin" />}
        </div>
        <h1 data-testid="payment-success-title" className="font-display text-3xl font-bold tracking-tight text-[#1E3A8A] mt-6">
          {paid ? t(lang, "payment_success_title") : t(lang, "payment_pending")}
        </h1>
        <p className="text-slate-600 mt-3">{paid ? t(lang, "payment_success_sub") : ""}</p>
        <Link to="/company">
          <Button data-testid="payment-back-btn" className="mt-8 rounded-full bg-[#1E3A8A] hover:bg-[#172554]">{t(lang, "back_to_dashboard")}</Button>
        </Link>
      </div>
    </Layout>
  );
}
